import { List } from 'react-admin';
import { AdsActionsDataGrid } from './AdsActionsDataGrid';
import { TablePagination } from '../../../helperComponents/TablePagination';
import { TitleAboveTable } from '../../../helperComponents/TitleAboveTable';
import { ToolBarRowStyleToggle } from '../../../helperComponents/ToolBarRowStyleToggle';
import { getAdsActionsFilters } from './helpers/adsActionsFilters';

export const AdsActionsList = (props) => {
  return (
    <>
      <TitleAboveTable title="Action Approvals" />
      <List
        {...props}
        title=" "
        actions={<ToolBarRowStyleToggle showSelectColumnsButton showExportButton={false} />}
        pagination={<TablePagination />}
        filters={getAdsActionsFilters()}
        filterDefaultValues={{ status: 'proposed' }}
        sort={{ field: 'proposed_at', order: 'DESC' }}
      >
        <AdsActionsDataGrid />
      </List>
    </>
  );
};
